/**
 * Created by chenqifeng on 2016/9/1.
 */

import $script from 'scriptJs';
import maple from 'maple';
export let loadWcSdk = function(deferred){
    if(maple.device.weixin){
        $script(['//res.wx.qq.com/open/js/jweixin-1.6.0.js'], 'bundle');
        $script.ready('bundle', function() {
            deferred.resolve();
        })
    }else{
        deferred.resolve();
    }
};